// Note: ideally we should always be able to determine which page we are on by
// using standard React features, e.g. passing down props. This is not always
// straightforward due to the complex dynamic routing used in Consumer, so
// instead we use an "escape hatch" approach here by checking for visible PDP
// DOM elements.
//
// We require the element to be visible (and not just present in the DOM)
// because Next.js route-segment caching can keep the previous segment in the
// DOM with `display: none` after a client-side navigation away from a PDP.
const isElementVisible = element =>
  !!element &&
  !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
  );

// The CON-8777 layout revamp renders its own roots, which count as a PDP too
const PDP_ROOT_SELECTORS = [
  '[data-xc="PDPDesktop"]',
  '[data-xc="PDPMobile"]',
  '[data-xc="PDPDesktopRevamp"]',
  '[data-xc="PDPMobileRevamp"]',
];

const isPDP = () =>
  PDP_ROOT_SELECTORS.some(selector =>
    isElementVisible(document.querySelector(selector))
  );

export default isPDP;
